import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PageSection } from '../page-section/page-section';

@Component({ selector: 'app-error-page', standalone: true, imports: [PageSection, RouterLink], templateUrl: './error-page.html', styleUrl: './error-page.scss' })
export class ErrorPage {
  readonly code = this.route.snapshot.data['code'] ?? '404';

  constructor(private route: ActivatedRoute) {}

  get title(): string {
    return this.code === '403' ? 'Access denied' : this.code === '500' ? 'Something went wrong' : 'Page not found';
  }

  get description(): string {
    if (this.code === '403') return 'This area is reserved for PhD Compass administrators.';
    if (this.code === '500') return 'An unexpected error occurred. Please retry or contact support if it persists.';
    return 'The page you requested does not exist or has moved.';
  }
}